<template>
  <div
    class="audio-block"
    @click="toggleAudio"
    @mouseenter="$store.commit('SET_POINTER', 'pointer')"
    @mouseleave="$store.commit('SET_POINTER', 'default')"
  ></div>
</template>

<script>
import audio from '@/scripts/audio';

export default {
  name: 'AudioBlock',

  data() {
    return {
      audio: null,
      playing: false,
    };
  },

  mounted() {
    this.$nextTick(() => {
      audio.get('background').ref.loop = true;
      audio.play('background');
    });
  },

  methods: {
    toggleAudio() {
      if (!this.playing) {
        audio.unmute();
        this.playing = true;
        window.dispatchEvent(new CustomEvent('audio-play'));
      } else {
        audio.mute();
        this.playing = false;
        window.dispatchEvent(new CustomEvent('audio-pause'));
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.audio-block {
  position: absolute;
  width: 200px;
  height: 50px;
  left: calc((100vw / 32) * 1);
  bottom: calc((100vh / 18) * 1);
}
</style>
